import _ from "lodash";

export const getIsDataPresent = (data) => {
  return !_.isEmpty(data)
}